import React from "react";
import "./Navbar.css"

// Import AOS library - rushii
import AOS from "aos";
import "aos/dist/aos.css"; 

AOS.init({
  duration: 1000, 
  easing: "ease-in-out", 
});


const DetailCard = (props) => {
  // display data using props
  return (
    <div>
      <div data-aos="fade-up"
        data-aos-anchor-placement="top-center" class="d-flex flex-column detailCardHover p-3 border-0">
        <h2 className="card-title text-center mt-4 underline-l">{props.title}</h2>
        <div class="card mb-3 mt-5 border-0 p-3" style={{ maxWidth: "100%" }}>
          <div class="row g-0">
            <div class="col-md-4">
              <img
                src={props.imageUrl}
                class="img-fluid rounded-4 p-1"
                alt="..."
              />
            </div>
            <div class="col-md-8">
              <div class="card-body text-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-calendar-event"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                  </svg>{" "}
                  <span className="me-3 text-decoration-none fw-bold">{props.date}</span>

                {" "}

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-geo-alt-fill "
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                  </svg>{" "}
                  <span className="fw-bold">{props.location}</span>
                  {/* <div className=""></div>
                   */}
                   <hr />
                {/* </p> */}
                <p class="card-text text-align-justify">
                  {props.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default DetailCard;
